'use strict';

/**
 * IE - Custom Modernizr Test
 *
 * Will add ie to <html> if the browser is Internet Explorer.
 *
 * @author Matthias Giger <matthias.giger@namics.com>
 */
Modernizr.addTest('ie', function () {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE ');
  var edge = ua.indexOf('Edge');

  return msie > 0 || edge > 0 || Boolean(navigator.userAgent.match(/Trident.*rv:11\./));
});